import { callingSystemService } from "../../../../Api/Services/CallingSystemService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import {
  IUpdateCallingSystemRequest,
  IUpdateCallingSystemResponse,
} from "../../../../Types/UsersCallingSystem";

export const employeeCallingSystemUpdateStatus = createServiceAsyncThunk<
  IUpdateCallingSystemResponse,
  IUpdateCallingSystemRequest
>(
  ACTION_NAMES.EMPLOYEE_CALLING_SYSTEM_UPDATE_STATUS,
  (payload) => callingSystemService.updateCallingSystemStatus(payload),
  ERROR_MESSAGES.EMPLOYEE_CALLING_SYSTEM_UPDATE_STATUS_FAILURE
);

export const employeeCallingSystemUpdateStatusSlice = createGenericSlice<
  IUpdateCallingSystemResponse,
  IUpdateCallingSystemRequest
>(
  SLICE_NAMES.EMPLOYEE_CALLING_SYSTEM_UPDATE_STATUS,
  employeeCallingSystemUpdateStatus
);

export const {
  clearError: clearEmployeeCallingSystemError,
  clearSuccessMessage: clearEmployeeCallingSystemSuccess,
} = employeeCallingSystemUpdateStatusSlice.actions;

export default employeeCallingSystemUpdateStatusSlice.reducer;
